export default {
    createBillboardMessage: 'Create Billboard Message',
    createIndividualMessage: 'Create Individual Message',
    updateBillboardMessage: 'Edit Billboard Message',
    updateIndividualMessage: 'Edit Individual Message',
    startDate: 'Start Date',
    endDate: 'End Date',
    topic: 'Topic',
    employeeNo: 'Employee No',
    description: 'Description',
    save: 'Save',
    cancel: 'Cancel',
    msgRequiredField: 'This field is required',
    msgExceededField: 'This field is exceeded 255 characters',
    msgError: 'Error Message',
    congratulation: 'Congratulation',
    msgErrorUpload: 'Error Upload',
    msgErrorUploadImageFail: 'Upload Image Fail',
    msgErrorSizeUpload: 'Image (.jpg,.jpeg,.png,.gif) only and file size lower than 10 MB',
    msgCreateSuccess: 'Message "$Name" has been created',
    msgUpdateSuccess: 'Message "$Name" has been updated'
}
